import {Component, TemplateRef} from "@angular/core";
import {Field} from "../models/field.model";
import {SERVICES} from "../services.config";
import {HttpClient} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {PlatformLocation} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {Observable} from "rxjs";
import {HelperService} from "../../../services/helperService";

@Component({
	selector: "tig-form-button",
	template: `
		<ng-template #OBJ_template_ref>
			<div class="modal-body text-center gray-bg">
				<p>{{OBJ_field_config.config?.buttonText|translate}}?</p>
				<button class="btn btn-primary btn-circle" (click)="execute()" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
				<button class="btn btn-warning btn-circle" (click)="hideModal()" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
			</div>
		</ng-template>
		<div
			class="form-group tig-form-button"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}"><span *ngIf="getLabelName().length">{{getLabelName()|translate}}</span>
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div *ngIf="button_show" class="col-lg-8">
				<button *ngIf="!OBJ_field_config?.config?.translation" class="tig-button b-r-xs" [ngClass]="OBJ_field_config?.config?.class" (click)="onClick(OBJ_template_ref)">{{OBJ_field_config.config.buttonText|translate}}</button>
				<div *ngIf="OBJ_field_config?.config?.translation" class="tig-button b-r-xs" [ngClass]="OBJ_field_config?.config?.class" (click)="is_open=!is_open" tigClickedOutside (onClickedOutside)="clickedOutside($event)">
					<div>{{OBJ_field_config.config?.buttonText|translate}}</div>
					<div class="tig-dropdown" [ngStyle]="{display:is_open?'block':'none'}">
						<ng-container *ngFor="let STR_lang of translateService.getLangs()">
							<button class="btn btn-primary btn-circle" type="button" (click)="language=STR_lang;onClick(OBJ_template_ref)">{{STR_lang.toUpperCase()}}</button>
						</ng-container>
					</div>
				</div>
				<div class="tig-hint">{{OBJ_field_config?.config?.hint|translate}}</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
			<div *ngIf="preview_links.length > 0" class="col-lg-8">
				<div *ngFor="let preview_link of preview_links;">
					<a href="{{preview_link}}" target="_blank">{{preview_link}}</a>
					<a class="m-l-sm" (click)="helperService.copyStringToClipboard(preview_link, 'oSuccess.sCopiedToClipboard')">
						<i class="fa fa-copy" title="{{translateService.instant('oMisc.sCopyToClipboard')}}"></i>
					</a>
				</div>
			</div>
		</div>
	`
})
export class FormButtonComponent extends Field {

	public language: string = "de";
	public is_open: boolean = false;
	public bsModalRef: BsModalRef;
	private modalOptions: ModalOptions = {
		animated: true,
		keyboard: true,
		backdrop: true,
		ignoreBackdropClick: true,
		class: "tig-modal-dialog"
	};
	public preview_links: Array<string> = [];
	public button_show: boolean = true;


	/**
	 * @param translateService
	 * @param helperService
	 * @param httpClient
	 * @param toastrService
	 * @param platformLocation
	 * @param router
	 * @param modalService
	 * @param activatedRoute
	 */
	constructor
	(
		public translateService: TranslateService,
		public helperService: HelperService,
		private httpClient: HttpClient,
		private toastrService: ToastrService,
		private platformLocation: PlatformLocation,
		private router: Router,
		private modalService: BsModalService,
		private activatedRoute: ActivatedRoute,
	) {
		super();
	} // end function constructor


	/**
	 * @param {TemplateRef<any>} templateRef
	 * @return void
	 */
	onClick(templateRef: TemplateRef<any>): void {
		let action = this.OBJ_field_config.config.action;

		if (
			// Newsletter - Editieren ; Testmailing und Vorschau kein Zwischenschritt
			action.function == "testmailing" || action.function == "nlpreview" ||
			(typeof action.security_question !== "undefined" && !action.security_question)
		) {
			this.execute(false);
		} else {
			this.bsModalRef = this.modalService.show(templateRef, this.modalOptions)
		}
	}


	/**
	 * @return void
	 */
	execute(hide_modal = true): void {
		// get service and function name
		let action = this.OBJ_field_config.config.action,
			function_name = action.function,
			service = null,
			params = this.activatedRoute.params;

		// NL-Test-Versand
		if (function_name == 'testmailing') {
			const url = action.url + params['_value'].id;
			window.open(url, '_blank');
		}

		if (function_name == "nlpreview") {
			let params = this.activatedRoute.params;
			const url = action.url + params['_value'].id + '/html/0/?preview=1';
			window.open(url, '_blank');
			return;
		}

		// Servicename wurde mit der Konfiguration uebergeben?
		if (typeof action.service !== 'undefined' && action.service.length > 0 && typeof SERVICES[action.service] !== 'undefined') {
			service = new SERVICES[action.service](this.httpClient);

			// Generierung der Vorschaulinks
			if (action.function == 'getPreviewLink') {
				this.getPreviewLink(service, action, params);
				return;
			}

			if (function_name == "sendMail") {

				// backend url
				let url = action.url;
				if (typeof action.mail != 'undefined') {

					// get translation object for mail
					let translation = this.translateService.translations[this.language][action.mail];
					if (typeof translation != 'undefined') {

						// build email address from
						let hostname = (this.platformLocation as any).location.hostname,
							hostnames = hostname.split("."),
							length = hostnames.length,
							host = hostnames[length - 2] + "." + hostnames[length - 1],
							from_addresses = translation["sFrom"].split("@"),
							from_address = from_addresses[0] + "@" + host,
							url_base = (this.platformLocation as any).location.origin;

						url_base += ((url_base.indexOf("localhost") == -1) ? "/wcms" : "");
						let url_password_reset = url_base + this.router.createUrlTree(["set-new-password"]).toString() + "/",
							formControlUsername = this.OBJ_form_group.get("username");

						if (formControlUsername != null && formControlUsername.value.length > 0) {
							let data = {
								identifier: "expert",
								mail: {
									from: from_address,
									to: formControlUsername.value,
									bcc: translation["sBcc"],
									subject: translation["sSubject"],
									sender: translation["sSender"],
									bodyText: translation["sBodyText"],
									bodyHtml: translation["sBodyHtml"],
									url: url_password_reset
								}
							};
							service[function_name](url, data).subscribe
							(
								// login successful
								result => {
									// output success
									this.toastrService.success(this.translateService.instant("oSuccess.sMailSendSuccessfully"));
								},
								// error
								error => {
									let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
									OBJ_form_control.setErrors({"mailSend": true});
									OBJ_form_control.markAsDirty();
								},
								// complete
								() => {
								}
							);
						} else {

							// output error
							let formControl = this.OBJ_form_group.get(this.OBJ_field_config.name);
							formControl.setErrors({"usernameRequired": true});
							formControl.markAsDirty();
							this.toastrService.success(this.translateService.instant("oError.sMissingTranslation"));

						} // end if

					} else {

						// output error
						let formControl = this.OBJ_form_group.get(this.OBJ_field_config.name);
						formControl.setErrors({"missingTranslation": true});
						formControl.markAsDirty();
						this.toastrService.success(this.translateService.instant("oError.sUsernameRequired"));

					} // end if

				} else {

					let data = {
						identifier: action.identifier,
						username: this.OBJ_form_group.get("username").value,
					};
					service[function_name](url, data).subscribe
					(
						// login successful
						result => {
							// output success
							this.toastrService.success(this.translateService.instant("oSuccess.sMailSendSuccessfully"));
						},
						// error
						error => {
							let formControl = this.OBJ_form_group.get(this.OBJ_field_config.name);
							formControl.setErrors({"mailSend": true});
							formControl.markAsDirty();
						},
						// complete
						() => {
						}
					);

				}

			}

		}

		// hide modal
		if (hide_modal) {
			this.hideModal();
		}
	}


	/**
	 * @return {void}
	 */
	hideModal(): void {
		this.bsModalRef.hide();
	}


	/**
	 * @param service
	 * @param action
	 * @param params
	 */
	getPreviewLink(service: any, action: any, params: Observable<any>) {
		let content_id = params['_value'].id,
			url = action.url + content_id;

		service[action.function](url).subscribe
		(
			// successful
			result => {
				result.map(token => {
					if (typeof action.sub_urls !== "undefined" && action.sub_urls.length > 0) {
						this.button_show = false;
						action.sub_urls.forEach((sub_url) => {
							this.preview_links.push('https://' + this.platformLocation.hostname.replace("dev-www", "www") +
								sub_url + content_id + '/preview/?pt=' + token._id);
						});
					}
				});
			},
			// error
			error => {
			},
			// complete
			() => {
			}
		);
	}


	/**
	 * @return void
	 */
	clickedOutside(OBJ_event): void {
		this.is_open = !OBJ_event.clickedOutside;
	}


}
